import React, { useState, useEffect } from 'react'
import Api from '@/_helpers/Api'
import { trans } from '@/_providers/Translation'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import { FormControlLabel, Switch } from '@mui/material'

const ReservationFieldModal = ({ open, field, onClose, onSave }) => {
    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        data: null,
        loading: false
    })
    const [localField, setLocalField] = useState(field)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (open && field && field.id) {
            setPopup({ overlay: true, modal: true, data: field, loading: true })
            setLoading(true)
            Api.get(`website/reservation-form-fields/${field.id}`)
                .then(res => {
                    setLocalField(res.data)
                    setPopup(prev => ({ ...prev, loading: false }))
                    setLoading(false)
                })
                .catch(() => {
                    setLocalField(field)
                    setPopup(prev => ({ ...prev, loading: false }))
                    setLoading(false)
                })
        } else {
            setPopup({ overlay: false, modal: false, data: null, loading: false })
            setLocalField(null)
        }
    }, [open, field])

    if (!popup.overlay || !popup.modal || !localField) return null

    const EDITABLE_FIELDS = ['appliance_model', 'serial_no', 'product_code', 'description']
    const isEditable = EDITABLE_FIELDS.includes(localField.field_name)

    const handleChange = e => {
        const { name, checked } = e.target
        setLocalField(prev => ({
            ...prev,
            [name]: checked ? 1 : 0
        }))
    }

    const handleSave = e => {
        e.preventDefault()
        setLoading(true)
        Api.post(`website/reservation-form-fields/${localField.id}`, localField)
            .then(res => {
                setLoading(false)
                if (onSave) onSave(res.data)
                if (onClose) onClose()
            })
            .catch(() => {
                setLoading(false)
                if (onClose) onClose()
            })
    }

    const handleHide = e => {
        if (e) e.preventDefault()
        if (onClose) onClose()
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form className={`${popup.modal ? 'show' : ''} popup-primary large`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.editReservationField')}
                        </h2>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', margin: '32px 0' }}>{trans('labels.loading')}</div>
                ) : (
                    <>
                        <h3 style={{ marginBottom: '24px' }}>
                            <span>ПОЛЕ:</span> {localField.field_name ? trans('website_form.' + localField.field_name) : localField.field_name}
                        </h3>

                        <div className='row'>
                            <div className='col'>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            name="is_visible"
                                            checked={localField.is_visible === 1}
                                            onChange={handleChange}
                                            disabled={!isEditable}
                                        />
                                    }
                                    label={trans('tables.visible')}
                                />

                                <FormControlLabel
                                    control={
                                        <Switch
                                            name="is_required"
                                            checked={localField.is_required === 1}
                                            onChange={handleChange}
                                            disabled={!isEditable}
                                        />
                                    }
                                    label={trans('tables.required')}
                                />
                            </div>
                        </div>
                    </>
                )}
                <div className="footer align-right" style={{ marginTop: 32 }}>
                    <button className="button" type="button" onClick={handleHide}>
                        {trans('buttons.cancel')}
                    </button>
                    <button className="button button-primary" type="submit" disabled={loading}>
                        {trans('buttons.save')}
                    </button>
                </div>
            </form>
        </div>
    )
}

export default ReservationFieldModal
